module.exports = __webpack_public_path__ + "img/marker_two_red1.5cbbc573.png";